/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Grid } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import ShopNowButton from './ShopNowButton';

const styles = (theme) => {
    const { typography, breakpoints: { minWidth, maxWidth } } = theme;
    return {
        productDetailsWrapper: {
            '&.descriptionContainer': {
                '& .flexItem': {
                    alignItems: 'center',
                    '& .title': {
                        fontSize: '65px',
                        fontFamily: typography.secondaryFontFamily,
                        fontWeight: 'normal',
                        color: '#2e2c2c',
                        marginBottom: '1.4rem',
                        marginTop: '.25rem',
                        lineHeight: '4.2rem',
                    },
                    [theme.breakpoints.up(minWidth.wiki_md_screen)]: {
                        paddingLeft: '15px',
                    },
                },
                '& .w-100': {
                    width: '100% !important',
                },
                '& .d-md-flex': {
                    [theme.breakpoints.up(maxWidth.small_screen_up)]: {
                        display: 'flex !important',
                    },
                },
                '& .flex-column-reverse': {
                    flexDirection: 'column-reverse !important',
                },
                '& .flex-md-row': {
                    [theme.breakpoints.up(maxWidth.small_screen_up)]: {
                        flexDirection: 'row !important',
                    },
                },
                '& img': {
                    maxWidth: '100%',
                    [theme.breakpoints.between(927, 960)]: {
                        width: '927px !important',
                    },
                },
            },
        },
    };
};

const ProductDetails = (props) => {
    const { pageData, classes } = props;
    const {
        product: {
            name,
            shortDescription,
            image,
            seo: { url },
        },
    } = pageData;
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 767);
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize, false);
    }, []);
    return (
        <div className={`${classes.productDetailsWrapper} descriptionContainer`}>
            <Grid container className="flex-column-reverse flex-md-row">
                <Grid item md={5}>
                    <img src={`${image?.path}${image?.name}x.jpg`} alt={name} />
                    { (isSmallScreen) ? <ShopNowButton slug={url} /> : ''}
                </Grid>
                <Grid item md={7} className="d-md-flex flexItem">
                    <div className="w-100">
                        <h1 className="title">{name}</h1>
                        <div>
                            { ReactHtmlParser(shortDescription) }
                        </div>
                        { (!isSmallScreen) ? <ShopNowButton slug={url} /> : ''}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

ProductDetails.propTypes = {
    pageData: object.isRequired,
    classes: object.isRequired,
};

export default compose(withStyles(styles))(ProductDetails);
